module.exports = __webpack_public_path__ + "img/video2-preview.2d1bcb19.gif";